import big from 'big.js';

export function roundUpToMultipleOfTens(val: number) {
	const absVal = Math.abs(val);
	let roundingVal = 0;

	if (absVal >= 0 && absVal < 10) {
		roundingVal = 1;
	} else if (absVal >= 10 && absVal < 100) {
		roundingVal = 10;
	} else if (absVal >= 100 && absVal < 1000) {
		roundingVal = 100;
	} else if (absVal >= 1000) {
		roundingVal = 1000;
	}

	return val >= 0 ? Math.ceil(val / roundingVal) * roundingVal : Math.floor(val / roundingVal) * roundingVal;
}

export function calculateRemainderPercentage(value: string): string {
	if (value) {
		const firstPartyOwnership = big(value);
		const total = big(100);
		return total.minus(firstPartyOwnership).toFixed(0);
	} else {
		return '';
	}
}

export function isValidBigNumber(input: string | number): boolean {
	try {
		new big(input);
		return true;
	} catch {
		return false;
	}
}
